(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.onScrollHandler = this.onScroll.bind(this);
      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = this;
      this.innerHeader = this.querySelector('.header');
      if (!this.innerHeader) return;
      this.sectionContainer = this.closest('.section-header');

      this.stickyType = this.dataset.stickyType || 'none';
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.headerBounds = { top: 0, bottom: 0 };

      this.setHeaderHeight();

      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.mediaQuery.addEventListener('change', this.setHeaderHeightHandler);
      window.addEventListener('resize', this.setHeaderHeightHandler);

      if (this.stickyType === 'none') {
        this.reset();
        return;
      }

      if (this.headerIsAlwaysSticky) {
        this.classList.add('shopify-section-header-sticky');
        return;
      }

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
    }

    setHeaderHeight() {
      if (!this.header) return;
      const offsetTop = this.sectionContainer ? this.sectionContainer.offsetTop : this.offsetTop;
      const height = this.offsetHeight;

      document.documentElement.style.setProperty('--header-height', `${height}px`);
      if (this.sectionContainer) {
        this.sectionContainer.style.minHeight = `${height}px`;
      }
      this.headerBounds = {
        top: offsetTop,
        bottom: offsetTop + height,
      };
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.mediaQuery) {
        this.mediaQuery.removeEventListener('change', this.setHeaderHeightHandler);
      }
      window.removeEventListener('resize', this.setHeaderHeightHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.stickyType !== 'on-scroll-up') return;

      if (scrollTop <= this.headerBounds.top) {
        this.classList.remove('scrolled-past-header');
        requestAnimationFrame(() => this.reset());
      } else if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.classList.add('scrolled-past-header');
        requestAnimationFrame(() => this.hide());
      } else if (scrollTop < this.currentScrollTop) {
        this.classList.add('scrolled-past-header');
        requestAnimationFrame(() => this.reveal());
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.classList.add('shopify-section-header-sticky', 'animate');
      this.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }
  
  } catch(e) { console.error(e); }
})();
})();
